import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Menu } from "lucide-react";
import { useTranslation } from "react-i18next";
import Sidebar from "./sidebar";
import LanguageSwitcher from "./language-switcher";

export default function DashboardLayout() {
  const { t } = useTranslation();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="flex min-h-svh bg-neutral-50">
      <Sidebar
        mobileOpen={mobileNavOpen}
        onMobileOpenChange={setMobileNavOpen}
      />
      <div className="flex-1 min-w-0 flex flex-col">
        {/* Mobile top bar */}
        <header className="md:hidden sticky top-0 z-30 bg-white border-b border-neutral-200 pt-[env(safe-area-inset-top)]">
          <div className="flex items-center justify-between h-14 px-3">
            <button
              type="button"
              onClick={() => setMobileNavOpen(true)}
              aria-label={t("nav.openMenu")}
              className="inline-flex items-center justify-center w-10 h-10 rounded-lg text-neutral-600 hover:bg-neutral-100 cursor-pointer"
            >
              <Menu className="w-5 h-5" />
            </button>
            <div className="flex items-center gap-1">
              <span className="font-heading text-base font-bold text-primary-600">
                Sport
              </span>
              <span className="font-heading text-base font-bold text-neutral-800">
                Scanner
              </span>
            </div>
            <LanguageSwitcher />
          </div>
        </header>

        <main className="flex-1 min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
